import { useAuthContext } from '../context/AuthContext';

export function useAuth() {
  const ctx = useAuthContext();
  return {
    user: ctx.user,
    isLoading: ctx.isLoading,
    isAuthenticated: ctx.isAuthenticated,
    isSubscribed: ctx.isSubscribed,
    isAdmin: ctx.isAdmin,
    track: ctx.user?.track ?? 'nursing',
    impersonating: ctx.impersonating,
    login: ctx.navigateToLogin,
    logout: ctx.logout,
    refetch: ctx.refetch,
  };
}
